<label [attr.id]="labelId" class="dropDownLabel">{{ placeholderAriaLabel || placeholder }}</label>
<div class="dropdown-list">
  <div *ngIf="!inputNotNeeded" class="selectWrap" [attr.aria-labelledby]="labelId"
    [attr.id]="inputId ? inputId : 'selectWrapId'" aria-haspopup="listbox" [attr.aria-expanded]="showDropDown"
    role="combobox" tabindex="0" [class.open]="showDropDown" (keydown)="handleSpanKeydown($event,'span')"
    (click)="toggle()">
    {{dropDownValue ? dropDownValue.name : prePopulateValue ? prePopulateValue.name : placeholder}}
  </div>
  <div *ngIf="inputNotNeeded" aria-haspopup="listbox" [attr.aria-labelledby]="labelId"
    [attr.aria-describedby]="pressEnterId + pressEnterId" [attr.id]="inputId ? inputId : 'selectWrapId'"
    class="selectWrap" role="combobox" [attr.aria-expanded]="showDropDown" tabindex="0" [class.open]="showDropDown"
    (keydown)="handleSpanKeydown($event,'span')" (click)="toggle()">
    {{dropDownValue ? dropDownValue.name : prePopulateValue ? prePopulateValue.name : placeholder}}
  </div>
  <ul class="select-list" role="listbox" aria-activedescendant="selected_option" [class.open]="showDropDown">
    <li role="option" *ngFor="let option of options" tabindex="-1"
      [attr.aria-label]="placeholderAriaLabel ? placeholderAriaLabel + option.name : option.name"
      [attr.aria-selected]="dropDownValue ? (dropDownValue.name == option.name ? true : false) : false"
      [attr.id]="option.name" (keydown)="handleSpanKeydown($event,'list')" (click)="selectItem(option, true)">
      {{option.name}}
    </li>
  </ul>
</div>
<span *ngIf="!dropDownValue" class="sr-only" [attr.id]="pressEnterId + pressEnterId"> Press enter to open the list of
  options</span>
<span *ngIf="dropDownValue" class="sr-only" [attr.id]="pressEnterId + pressEnterId"> {{dropDownValue.name}} Press enter
  to open the list of options</span>